export default __webpack_public_path__ + "static/media/pic_case_create.83c9d445.png";